var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VContainer',{staticClass:"pt-10",attrs:{"fluid":""}},[_c(_setup.SContactUs,{on:{"setGlobalLoading":_setup.setGlobalLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }